import packageJson from "../../package.json";

const config = {
  version: packageJson.version,
  commitHash: __COMMIT_HASH__,
  mode: import.meta.env.MODE || "development",
  env: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE,
  devMode: import.meta.env.VITE_DEV_MODE === "true",
  emulator: import.meta.env.MODE === "emulator",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  typesense: {
    host: import.meta.env.VITE_TYPESENSE_HOST,
    port: import.meta.env.VITE_TYPESENSE_PORT || 443,
    apiKey: import.meta.env.VITE_TYPESENSE_API_KEY,
    collections: {
      customer: import.meta.env.VITE_TYPESENSE_CUSTOMER_COLLECTION,
      technician: import.meta.env.VITE_TYPESENSE_TECHNICIAN_COLLECTION,
      appointment: import.meta.env.VITE_TYPESENSE_APPOINTMENT_COLLECTION,
      generator: import.meta.env.VITE_TYPESENSE_GENERATOR_COLLECTION,
    },
  },
};

export { config };
